import React, { useState, useEffect } from 'react';
import Navbar from '../../dashboard/navbar';
import Sidebar from '../../dashboard/sidebar';
import { Link } from 'react-router-dom';
import { Table, Modal, Button } from 'react-bootstrap';
import { FaPlus, FaEdit, FaSortAmountUp, FaSortAmountDown, FaArrowRight, FaArrowLeft } from 'react-icons/fa';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';

import useAuth from '../../dashboard/useAuth';

const Liste_groupe_processus = ({ titre }) => {
    useAuth();
    const [groupeProcessus, setGroupeProcessus] = useState([]);
    const [expandedDescriptions, setExpandedDescriptions] = useState({});
    const [selectedGroupeProcessus, setSelectedGroupeProcessus] = useState(null);
    const [sortConfig, setSortConfig] = useState({ key: 'id', direction: 'ascending' });
    const [searchTerm, setSearchTerm] = useState('');
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const location = useLocation();
    const navigate = useNavigate();
    const user_id = localStorage.getItem('user_id');
    const totalItems = groupeProcessus.length;  // Si 'formationList' contient toutes les formations
    const [groupeProcessusDescriptionOverflows, setgroupeProcessusDescriptionOverflows] = useState({});
    const [showImportModal, setShowImportModal] = useState(false);
    const [file, setFile] = useState(null);

    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Groupe Processus";
        }
    }, [user_id]);


    const [groupeprocess, setgroupeprocess] = useState([]);
    const fetchGroupeProcessus = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + '/listes-groupes-processus/');
            if (response.ok) {
                const data = await response.json();
                setGroupeProcessus(data);
            } else {
                console.error('Erreur lors de la récupération des groupes processus');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };

    useEffect(() => {
        fetchGroupeProcessus();
    }, []);

    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        // setTimeout(() => {
        //     setAlert({ message: '', type: '' });
        // }, 7000);
    };


    const fermerNotif = () => {
        setAlert({ message: '', type: '' });
    }

    const handleRowClick = (groupeProcessus) => {
        setSelectedGroupeProcessus(groupeProcessus);
    };





    const [showClearModal, setShowClearModal] = useState(false); // Gérer l'affichage du modal



    const clearTable = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/vider-groupe-processus/`, {
                method: 'POST',
            });
            const data = await response.json();

            if (response.ok) {
                showAlert("Table groupe-processus vidée avec succès !");
                fetchGroupeProcessus()
            } else {
                console.error('Erreur lors de la suppression des groupe-processus.', data);
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        } finally {
            setShowClearModal(false); // Ferme le modal
        }
    };


    // Gérer l'import du fichier
    const handleFileUpload = async () => {
        if (!file) return; // Si aucun fichier n'est sélectionné, ne rien faire

        const formData = new FormData();
        formData.append('file', file);

        try {
            const response = await fetch(
                `${process.env.REACT_APP_HOTE}/importer-groupe-processus/`,
                {
                    method: 'POST',
                    body: formData,
                }
            );

            const data = await response.json();

            if (response.ok) {
                let successMessage = `Import réussi : ${data.imported_count} ajouté(s), ${data.skipped_count} ignoré(s)`;

                if (data.message) {
                    successMessage += `\n📝 Message: ${data.message}`;
                }

                showAlert(successMessage, 'success');
                fetchGroupeProcessus();
            } else {
                let errorMessage = 'Erreur lors de l\'import : ';

                if (data.message) {
                    errorMessage += `\n⚠️ ${data.message}`;
                }
                if (data.errors_html && data.errors_html.length > 0) {
                    errorMessage += `\n❌ Erreurs détectées :\n- ${data.errors.join('\n- ')}`;
                }
                if (data.details) {
                    errorMessage += `\nℹ️ Détails : ${data.details}`;
                }

                showAlert(errorMessage, 'danger');
            }
        } catch (error) {
            console.error('Erreur d\'importation :', error);
            showAlert('🚨 Erreur réseau : Impossible d\'importer le fichier.', 'danger');
        } finally {
            setShowImportModal(false); // Fermer le modal après l'import
            setFile(null); // Réinitialiser le fichier sélectionné
        }
    };




    // Fonction pour gérer l'événement de sélection de fichier
    const handleFileChange = (event) => {
        const selectedFile = event.target.files ? event.target.files[0] : null; // Vérifie si files existe
        setFile(selectedFile); // Mettre à jour l'état du fichier
    };


    const handleDeleteGroupeProcessus = async () => {
        if (selectedGroupeProcessus) {
            try {
                const response = await fetch(`${process.env.REACT_APP_HOTE}/supprimer-groupe-processus/${selectedGroupeProcessus.ordre}/`, {
                    method: 'DELETE',
                });

                if (response.ok) {
                    setGroupeProcessus(groupeProcessus.filter((groupeProcessus) => groupeProcessus.id !== selectedGroupeProcessus.id));
                    showAlert("Groupe processus supprimé avec succès !");
                } else {
                    const errorData = await response.json();
                    showAlert(`Erreur lors de la suppression du groupe processus : ${errorData.error || 'Erreur inconnue'}`);
                    console.error('Erreur lors de la suppression du groupe processus', errorData);
                }
            } catch (error) {
                showAlert('Erreur réseau : Impossible de supprimer le groupe processus.');
                console.error('Erreur réseau:', error);
            } finally {
                setShowDeleteModal(false);
                setSelectedGroupeProcessus(null);
            }
        }
    };

    const handleToggleDescription = (id) => {
        console.log("Toggling description for ID:", id); // Vérifiez l'identifiant
        setExpandedDescriptions((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    };


    const filteredGroupeProcessus = groupeProcessus.filter(groupeProcessus =>
        groupeProcessus.titre_fr.toLowerCase().includes(searchTerm.toLowerCase()) ||
        groupeProcessus.description_fr.toLowerCase().includes(searchTerm.toLowerCase()) ||
        groupeProcessus.ajoute_par.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const sortedGroupeProcessus = [...filteredGroupeProcessus].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
    });

    const indexOfLastGroupeProcess = currentPage * itemsPerPage;
    const indexOfFirstGroupeProcess = indexOfLastGroupeProcess - itemsPerPage;
    const currentGroupeProcess = sortedGroupeProcessus.slice(indexOfFirstGroupeProcess, indexOfLastGroupeProcess);
    const totalPages = Math.ceil(sortedGroupeProcessus.length / itemsPerPage);

    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    const checkgroupeProcessusDescriptionOverflow = (groupeprocess) => {
        groupeprocess.forEach((domaine) => {
            const element = document.getElementById(`groupeProcessus-description_fr-${groupeProcessus.id}`);
            if (element) {
                setgroupeProcessusDescriptionOverflows((prev) => ({
                    ...prev,
                    [groupeProcessus.id]: element.scrollHeight > element.clientHeight,
                }));
            }
        });
    };

    useEffect(() => {
        checkgroupeProcessusDescriptionOverflow(groupeprocess);
    }, [groupeprocess]);

    const handleModifier = (groupeProcessus) => {
        if (groupeProcessus) {
            navigate(`/Modifier-groupe-processus`, {
                state: { groupeProcessus_id: groupeProcessus.ordre },
            });
        }
    };

    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupe.includes("QCM")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className="mb-1"><i className="fa fa-bookmark-o"></i> Liste des Groupes Processus {groupeProcessus.titre_fr}</h2>
                            <small>Admisnistration des Groupes processus qui correspondent aux cours ou chapitres</small>
                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={'/admin'}>Administration</Link>
                                    </li>
                                    {/* <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={'/Liste-groupe-processus'}>Groupes Processus</Link>
                                    </li> */}
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        Liste des Groupes Processus {groupeProcessus.titre_fr}
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>
                    <div className="mt-3 wrapper wrapper-content animated fadeInRight">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5>Liste des Groupes processus</h5>
                            <div>
                                <button
                                    onClick={() => setShowClearModal(true)} // Ouvre le modal
                                    className="btn btn-danger ms-2 mr-2"
                                >
                                    Vider la table
                                </button>
                                <button
                                    onClick={() => handleDeleteGroupeProcessus(selectedGroupeProcessus)}
                                    className={`btn ms-2 mr-2 ${selectedGroupeProcessus ? 'btn-success' : 'btn-default text-dark'}`}
                                    disabled={!selectedGroupeProcessus}
                                >
                                    <FaEdit /> Supprimer
                                </button>
                                <button
                                    onClick={() => handleModifier(selectedGroupeProcessus)}
                                    className={`btn ms-2 mr-2 ${selectedGroupeProcessus ? 'btn-success' : 'btn-default text-dark'}`}
                                    disabled={!selectedGroupeProcessus}
                                >
                                    <FaEdit /> Modifier
                                </button>
                                <Link to={`/Ajouter-groupe-processus`} className="btn btn-success ms-2 mr-2">
                                    <FaPlus /> Ajouter
                                </Link>
                                <button
                                    className="btn btn-success ms-2"
                                    onClick={() => setShowImportModal(true)} // Ouvrir le modal
                                >
                                    Importer CSV
                                </button>
                            </div>
                        </div>


                        {alert.message && (
                            <div className={`alert alert-${alert.type} row justify-content-between position-relative`}>
                                <div
                                    // Utilisation de dangerouslySetInnerHTML pour afficher le message HTML
                                    dangerouslySetInnerHTML={{ __html: alert.message }}
                                />

                                <span
                                    onClick={fermerNotif}
                                    style={{
                                        position: 'absolute',
                                        top: '0px',   // Ajustez l'espacement comme vous le souhaitez
                                        right: '10px', // Ajustez l'espacement comme vous le souhaitez
                                        cursor: 'pointer'
                                    }}
                                >
                                    <i className='fa fa-close'></i>
                                </span>
                            </div>
                        )}

                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content">
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <select
                                                id="itemsPerPage"
                                                value={itemsPerPage}
                                                onChange={(e) => {
                                                    setItemsPerPage(Number(e.target.value));
                                                    setCurrentPage(1);
                                                }}
                                                className="form-select bg-default p-1"
                                                style={{ width: 'auto', border: '1px black solid', borderRadius: '5px' }}
                                            >
                                                <option value={10}>10</option>
                                                <option value={20}>20</option>
                                                <option value={50}>50</option>
                                            </select>
                                            <input
                                                type="text"
                                                placeholder="Rechercher..."
                                                className="form-control"
                                                style={{ maxWidth: '150px', width: '100%' }} // Largeur fixe ou maximale selon besoin
                                                value={searchTerm}
                                                onChange={(e) => setSearchTerm(e.target.value)}
                                            />
                                        </div>
                                        <div className="table-responsive" style={{ fontSize: '11px' }}>
                                            <table className="footable table table-stripped footable-loaded tablet breakpoint" data-page-size="8" data-filter="#filter">
                                                <thead>
                                                    <tr>
                                                        <th onClick={() => handleSort('titre_fr')}
                                                            className='text-secondary text-wrap d-none d-md-table-cell'
                                                        >
                                                            Titre
                                                            {sortConfig.key === 'titre_fr'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                        </th>
                                                        <th onClick={() => handleSort('description_fr')}
                                                            className='text-secondary text-wrap d-none d-md-table-cell'
                                                        >
                                                            Description
                                                            {sortConfig.key === 'description_fr'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                        </th>
                                                        <th onClick={() => handleSort('ajoute_par')}>Ajouté par {sortConfig.key === 'ajoute_par'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                        <th onClick={() => handleSort('ordre')}>Ordre {sortConfig.key === 'ordre'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {currentGroupeProcess.map((groupeProcessus) => (
                                                        <tr
                                                            key={groupeProcessus.id}
                                                            onClick={() => handleRowClick(groupeProcessus)}
                                                            className={`bg-white ${selectedGroupeProcessus && selectedGroupeProcessus.id === groupeProcessus.id ? 'bg-success text-white' : ''}`}
                                                        >
                                                            <td>
                                                                {groupeProcessus.titre_fr}
                                                                <div className='lesInfos'>
                                                                    <small>Description : {groupeProcessus.description_fr}</small><br />
                                                                    {/* <small>Ajouté par : {domaine.ajoute_par}</small> */}
                                                                </div>
                                                            </td>
                                                            <td className="d-none d-md-table-cell">
                                                                {groupeProcessus.description_fr}
                                                            </td>
                                                            <td className="d-none d-md-table-cell">
                                                                {groupeProcessus.ajoute_par}
                                                            </td>
                                                            <td className="d-none d-md-table-cell">
                                                                {groupeProcessus.ordre}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>

                                        {/* Pagination Controls */}
                                        <div className="d-flex justify-content-between align-items-center mt-3">
                                            <div className="dataTables_info" role="status" aria-live="polite">
                                                {totalItems === 0
                                                    ? "Aucun élément à afficher"
                                                    : `Élément ${indexOfFirstGroupeProcess + 1} à ${Math.min(indexOfLastGroupeProcess, totalItems)} sur ${totalItems}`}
                                            </div>
                                            <div>
                                                <button
                                                    onClick={() => setCurrentPage(currentPage > 1 ? currentPage - 1 : 1)}
                                                    className="btn btn-light mx-1"
                                                    disabled={currentPage === 1}
                                                >
                                                    <FaArrowLeft />
                                                </button>

                                                {(() => {
                                                    const pagesToShow = 5; // Nombre total de pages à afficher
                                                    let startPage = Math.max(1, currentPage - Math.floor(pagesToShow / 2));
                                                    let endPage = Math.min(totalPages, startPage + pagesToShow - 1);

                                                    // Ajuster le startPage si la fin dépasse le total des pages
                                                    if (endPage - startPage < pagesToShow - 1) {
                                                        startPage = Math.max(1, endPage - pagesToShow + 1);
                                                    }

                                                    const pageButtons = [];

                                                    // Ajout des boutons de pages
                                                    for (let i = startPage; i <= endPage; i++) {
                                                        pageButtons.push(
                                                            <button
                                                                key={i}
                                                                onClick={() => setCurrentPage(i)}
                                                                className={`btn ${currentPage === i ? 'btn-default' : 'btn-light'} mx-1`}
                                                            >
                                                                {i}
                                                            </button>
                                                        );
                                                    }

                                                    return pageButtons;
                                                })()}

                                                <button
                                                    onClick={() => setCurrentPage(currentPage < totalPages ? currentPage + 1 : totalPages)}
                                                    className="btn btn-light mx-1"
                                                    disabled={currentPage === totalPages}
                                                >
                                                    <FaArrowRight />
                                                </button>

                                                {/* Bouton pour aller à la dernière page */}
                                                <button
                                                    onClick={() => setCurrentPage(totalPages)}
                                                    className="btn btn-light mx-1"
                                                    disabled={currentPage === totalPages}
                                                >
                                                    {totalPages}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Delete Modal */}
                        <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
                            <Modal.Header closeButton>
                                <Modal.Title>Supprimer Groupe Processus</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                Êtes-vous sûr de vouloir supprimer ce groupe processus ?
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
                                    Annuler
                                </Button>
                                <Button variant="danger" onClick={handleDeleteGroupeProcessus}>
                                    Supprimer
                                </Button>
                            </Modal.Footer>
                        </Modal>


                        <Modal show={showImportModal} onHide={() => setShowImportModal(false)}>
                            <Modal.Header>
                                <Modal.Title>Importer un fichier CSV</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div>
                                    <input
                                        type="file"
                                        accept=".csv"
                                        onChange={handleFileChange} // Utiliser la fonction modifiée ici
                                    />
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={() => setShowImportModal(false)}>
                                    Annuler
                                </Button>
                                <Button
                                    variant="success"
                                    onClick={handleFileUpload}
                                    disabled={!file} // Désactiver le bouton si aucun fichier n'est sélectionné
                                >
                                    Importer
                                </Button>
                            </Modal.Footer>
                        </Modal>


                        <Modal show={showClearModal} onHide={() => setShowClearModal(false)}>
                            <Modal.Header>
                                <Modal.Title>Confirmation</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                Êtes-vous sûr de vouloir vider la table ? Cette action est irréversible.
                            </Modal.Body>
                            <Modal.Footer>
                                <button className="btn btn-secondary" onClick={() => setShowClearModal(false)}>
                                    Annuler
                                </button>
                                <button className="btn btn-success" onClick={clearTable}>
                                    Vider
                                </button>
                            </Modal.Footer>
                        </Modal>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Liste_groupe_processus;
